import * as Yup from 'yup';

export default Yup.object().shape({
  agent: Yup.object().nullable()
});
